import {BaseConfig} from "../../infrastructure/config/base-config";
import {PromotedSponsorshipModuleTerms} from "./promoted-sponsorship-module.terms";

export class PromotedSponsorshipModuleConfig extends BaseConfig {

  static injectables = [PromotedSponsorshipModuleTerms];

  constructor(terms: PromotedSponsorshipModuleTerms){
    super('promotedSponsorshipModule', null, terms);
  }
}
